import chargeComponent from './charge.component';

const chargeModule = angular.module('charge', [
])
  .component('charge', chargeComponent)
  .name;

export default chargeModule;
